// utils/dteAmounts.js
const IVA_RATE = 0.19

const getSelfCode = row => String(row?.dte_type_code ?? '')

const getReferencedCode = row => {
  const refType = row?.references?.[0]?.reference_type // ej: "33 - Factura Electrónica"
  if (!refType) return ''
  const match = String(refType)
    .trim()
    .match(/^(\d+)/) // toma "33" o "34"
  return match?.[1] ?? ''
}

/**
 * baseCode:
 * - si es NC (61) y tiene referencias, usa el código del documento referenciado (33/34)
 * - si no, usa su propio dte_type_code
 */
export const getBaseDteCode = row => {
  const self = getSelfCode(row)
  if (self === '61') {
    const ref = getReferencedCode(row)
    return ref || self
  }
  return self
}

/**
 * Retorna un desglose listo para UI.
 * kind:
 * - 'afecto' => mostrar IVA + Neto (33)
 * - 'exento' => mostrar Exento (34)
 * - 'otro'   => fallback
 */
export const calcAmountsForRow = row => {
  const total = Number(row?.amount_with_iva ?? 0) || 0
  const baseCode = getBaseDteCode(row)

  // 33 => afecto (IVA)
  if (baseCode === '33') {
    const neto = Math.round(total / (1 + IVA_RATE))
    const iva = Math.round(total - neto)
    return {
      kind: 'afecto',
      total,
      neto,
      iva,
      exento: null
    }
  }

  // 34 => exento (sin IVA)
  if (baseCode === '34') {
    return {
      kind: 'exento',
      total,
      neto: null,
      iva: null,
      exento: total
    }
  }

  // fallback
  return {
    kind: 'otro',
    total,
    neto: total,
    iva: null,
    exento: null
  }
}
